import request from '@/core/http/request'

// 新增销售订单
export function smgtSalesOrderDoc_add(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/add',
    method: 'post',
    data: data
  })
}

// 修改销售订单
export function smgtSalesOrderDoc_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/update',
    method: 'post',
    data: data
  })
}

// 销售数据概览
export function smgtSalesOrderDoc_getSalesDataInfo(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/getSalesDataInfo',
    method: 'post',
    data: data
  })
}

// 查询销售订单
export function smgtSalesOrderDoc_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesOrderDocDetail/selectSalesOrderListWithExt',
    method: 'post',
    data: data
  })
}

// ids查询销售订单
export function selectSalesOrderListByIds(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesOrderDocDetail/selectSalesOrderListByIds',
    method: 'post',
    data: data
  })
}

// 查询可供应商代发销售订单
export function selectSalesOrderListWithExtForConsignmentOrderDoc(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesOrderDocDetail/selectSalesOrderListWithExtForConsignmentOrderDoc',
    method: 'post',
    data: data
  })
}

// 删除销售订单
export function smgtSalesOrderDoc_delete(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/delete',
    method: 'post',
    data: data
  })
}

// 销售订单详情
export function smgtSalesOrderDoc_view(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/view',
    method: 'get',
    params: data
  })
}

// 销售订单关联财务单据（未对账收款单、销售退货单）
export function smgtSalesOrderDoc_relatedFinanceDocs(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/relatedFinanceDocs',
    method: 'post',
    data: data
  })
}

// 销售订单审核
export function smgtSalesOrderDoc_checkSmgtSalesOrderDocDoc(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/checkSmgtSalesOrderDocDoc',
    method: 'post',
    data: data
  })
}

// 所有可出库的销售订单
export function smgtSalesOrderDocDetail_saleUnDeliveryOrderList(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesDeliveryDoc/selectUnDeliveryOrderList',
    method: 'post',
    data: data
  })
}

// 查询销售出库
export function smgtSalesDeliveryDoc_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesDeliveryDocDetail/selectSalesDeliveryListWithExt',
    method: 'post',
    data: data
  })
}

// ids查询销售出库
export function selectSalesDeliveryListByIds(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesDeliveryDocDetail/selectSalesDeliveryListByIds',
    method: 'post',
    data: data
  })
}

// 新增销售出库
export function smgtSalesDeliveryDoc_add(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesDeliveryDoc/add',
    method: 'post',
    data: data
  })
}

// 修改销售出库
export function smgtSalesDeliveryDoc_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesDeliveryDoc/update',
    method: 'post',
    data: data
  })
}

// 销售出库详情
export function smgtSalesDeliveryDoc_view(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesDeliveryDoc/view',
    method: 'get',
    params: data
  })
}

// 删除销售出库
export function smgtSalesDeliveryDoc_delete(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesDeliveryDoc/delete',
    method: 'post',
    data: data
  })
}

// 审核销售出库
export function smgtSalesDeliveryDoc_checkSmgtSalesDeliveryDoc(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesDeliveryDoc/checkSmgtSalesDeliveryDoc',
    method: 'post',
    data: data
  })
}

// 查询可生成的收款账单
export function smgtSalesStatementDoc_saleUnreconciledDeliveryGrouplist(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesStatementDoc/saleUnreconciledDeliveryGroupList',
    method: 'post',
    data: data
  })
}

// 查询销售对账单
export function smgtSalesDeliveryDoc_listAll(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesStatementDoc/getStatementDocListByMoHu',
    method: 'post',
    data: data
  })
}

// 销售对账单展开
export function smgtSalesDeliveryDoc_selectSalesStatementOtherListWithExt(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesStatementDoc/selectSalesStatementOtherListWithExt',
    method: 'post',
    data: data
  })
}

// 根据全局搜索码展开对账单列表
export function smgtSalesStatementDoc_expandStatementDocListByGlobalSearchNumber(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesStatementDoc/expandStatementDocListByGlobalSearchNumber',
    method: 'post',
    data: data
  })
}


// 查询销售对账单
export function selectSalesDeliveryOtherListWithExt(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesDeliveryDocDetail/selectSalesDeliveryOtherListWithExt',
    method: 'post',
    data: data
  })
}

// 按客户分组的对账汇总
export function smgtSalesStatementDoc_getSalesUnInvoiceStatementGroupList(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesStatementDoc/getSalesUnInvoiceStatementGroupList',
    method: 'post',
    data: data
  })
}

//根据客户ID查询账单数据
export function smgtSalesStatementDoc_getStatementDocListByCustomerId(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesStatementDoc/getStatementDocListByCustomerId',
    method: 'post',
    data: data
  })
}

//客户批量开发票
export function smgtSalesStatementDoc_doMergeInvoicingForStatementReceipt(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesStatementDoc/doMergeInvoicingForStatementReceipt',
    method: 'post',
    data: data
  })
}

// 客户合并收款
export function smgtSalesStatementDoc_doMergeCollectionForStatementReceipt(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesStatementDoc/doMergeCollectionForStatementReceipt',
    method: 'post',
    data: data
  })
}

// 根据客户ID查询可对账数据
export function smgtSalesDeliveryDoc_saleUnreconciledDeliveryList(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesStatementDoc/saleUnreconciledDeliveryList',
    method: 'post',
    data: data
  })
}

// 新增销售对账单
export function smgtSalesStatementDoc_add(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesStatementDoc/add',
    method: 'post',
    data: data
  })
}

// 删除付款账单
export function deleteAccountFlowOrCustomerAdvancePaymentDetail(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesStatementDoc/deleteAccountFlowOrCustomerAdvancePaymentDetail',
    method: 'post',
    data: data
  })
}

// 修改销售对账单
export function smgtSalesStatementDoc_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesStatementDoc/update',
    method: 'post',
    data: data
  })
}

// 客户对账单补充更新（审核后仍可维护订单附件）
export function smgtSalesStatementDoc_supplementUpdate(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesStatementDoc/supplementUpdate',
    method: 'post',
    data: data
  })
}

// 销售对账详情
export function smgtSalesStatementDoc_view(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesStatementDoc/view',
    method: 'get',
    params: data
  })
}
// 销售账单删除
export function smgtSalesStatementDoc_delete(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesStatementDoc/delete',
    method: 'post',
    data: data
  })
}

// 销售对账审核
export function smgtSalesStatementDoc_checkSmgtSalesStatementDoc(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesStatementDoc/checkSmgtSalesStatementDoc',
    method: 'post',
    data: data
  })
}

// 销售对账收款详情
export function smgtSalesStatementDoc_viewWithAccountFlow(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesStatementDoc/viewWithAccountFlow',
    method: 'get',
    params: data
  })
}

// 新增销售对账收款
export function smgtSalesStatementDoc_addCollection(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesStatementDoc/addCollection',
    method: 'post',
    data: data
  })
}

// 批量全额收款（客户对账单）
export function smgtSalesStatementDoc_batchAddCollection(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesStatementDoc/batchAddCollection',
    method: 'post',
    data: data
  })
}

// 查询账单发票
export function smgtSalesStatementDoc_viewWithInvoice(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesStatementDoc/viewWithInvoice',
    method: 'get',
    params: data
  })
}

// 新增账单发票
export function smgtSalesStatementInvoice_add(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesStatementInvoice/add',
    method: 'post',
    data: data
  })
}

// 删除账单发票
export function deleteSalesStatementInvoiceDoc(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesStatementInvoice/deleteSalesStatementInvoiceDoc',
    method: 'post',
    data: data
  })
}

// 销售订单详情修改
export function smgtSalesOrderDocDetail_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesOrderDocDetail/update',
    method: 'post',
    data: data
  })
}

// 销售出库详情修改
export function smgtSalesDeliveryDocDetail_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesDeliveryDocDetail/update',
    method: 'post',
    data: data
  })
}

// 销售订单合计
export function smgtSalesOrderDocDetail_getSalesOrderDocDetailListForSummary(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesOrderDocDetail/getSalesOrderDocDetailListForSummary',
    method: 'post',
    data: data
  })
}

// 销售出库合计
export function smgtSalesDeliveryDocDetail_getSalesDeliveryDocDetailListForSummary(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesDeliveryDocDetail/getSalesDeliveryDocDetailListForSummary',
    method: 'post',
    data: data
  })
}

// 销售账单合计
export function smgtSalesStatementDoc_getSalesStatementDocDetailListForSummary(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesStatementDoc/getSalesStatementDocDetailListForSummary',
    method: 'post',
    data: data
  })
}

// 查询订单
export function smgtSalesOrderDoc_orderList(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/list',
    method: 'post',
    data: data
  })
}

// 查询客户订单号
export function getSalesOrderCustomerOrderNumberList(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/getSalesOrderCustomerOrderNumberList',
    method: 'post',
    data: data
  })
}
// 销售报价单新增
export function sell_quotation(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesQuotationDoc/add',
    method: 'post',
    data: data
  })
}

// 销售报价单修改
export function sell_quotation_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesQuotationDoc/update',
    method: 'post',
    data: data
  })
}

// 销售报价单主表修改
export function sell_quotationDoc_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesQuotationDoc/updateSalesQuotationOrderDoc',
    method: 'post',
    data: data
  })
}

// 销售报价单删除
export function sell_quotation_delete(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesQuotationDoc/delete',
    method: 'post',
    data: data
  })
}

// 销售报价单详情修改
export function smgtSalesQuotationDocDetail_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesQuotationDocDetail/update',
    method: 'post',
    data: data
  })
}
// 销售报价单列表
export function sell_quotation_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesQuotationDocDetail/selectSalesQuotationList',
    method: 'post',
    data: data
  })
}

// 销售报价主表
export function smgtSalesQuotationDoc_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesQuotationDoc/getSalesQuotationList',
    method: 'post',
    data: data
  })
}

// 销售报价单详细
export function sell_quotation_view(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesQuotationDoc/view',
    method: 'get',
    params: data
  })
}

// 新增销售退货
export function sell_return_add(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesChargebackDoc/add',
    method: 'post',
    data: data
  })
}

// 修改销售退货
export function smgtSalesChargebackDoc_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesChargebackDoc/update',
    method: 'post',
    data: data
  })
}

// 删除销售退货
export function smgtSalesChargebackDoc_delete(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesChargebackDoc/delete',
    method: 'post',
    data: data
  })
}

// 修改销售退货
export function sell_return_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesChargebackDocDetail/update',
    method: 'post',
    data: data
  })
}

// 新增销售退货详细
export function sell_return_view(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesChargebackDoc/view',
    method: 'get',
    params: data
  })
}

// 销售退货列表
export function sell_return_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesChargebackDocDetail/getSalesChargebackOrderList',
    method: 'post',
    data: data
  })
}

// 销售退货审核
export function sell_return_check(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesChargebackDoc/checkSmgtSalesChargebackDoc',
    method: 'post',
    data: data
  })
}

// 销售退货单是否质检完成（占位：后端补充实现）
// 返回 { data: true/false }，true 表示可进行退货入库
export function salesChargebackDoc_isQualityFinished(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesChargebackDoc/isQualityFinished',
    method: 'post',
    data: data
  })
}

// 销售退货入库。
export function sell_return_warehouseIn(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesChargebackDoc/doEnranceInSalesChargebackReceiptDoc',
    method: 'post',
    data: data
  })
}

// 销售退货详细
export function sell_return_UnChargebackOrderList(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesChargebackDoc/getSaleUnChargebackOrderList',
    method: 'post',
    data: data
  })
}

// 销售报价审核
export function sell_quotation_check(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesQuotationDoc/checkSalesQuotationOrderDoc',
    method: 'post',
    data: data
  })
}

// 报价产品新增
export function material_addList(data) {
  return request({
    url: '/qingguang/tenantbussiness/material/addList',
    method: 'post',
    data: data
  })
}

// 销售报价打印
export function smgtSalesQuotationDoc_printInfoSalesQuotationById(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesQuotationDoc/printInfoSalesQuotationById',
    method: 'get',
    params: data
  })
}

// 新增修改精细报价单
export function fineQuotationDoc_saveOrUpdate(data) {
  return request({
    url: '/qingguang/tenantbussiness/fineQuotationDoc/saveOrUpdate',
    method: 'post',
    data: data
  })
}

// 新增修改精细报价单（分离）
export function fineQuotationDoc_saveOrUpdateSeparate(data) {
  return request({
    url: '/qingguang/tenantbussiness/fineQuotationDoc/saveOrUpdateSeparate',
    method: 'post',
    data: data
  })
}

// 查询精细报价单
export function fineQuotationDoc_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/fineQuotationDocDetail/selectFineQuotationDocList',
    method: 'post',
    data: data
  })
}

// 删除精细报价单
export function fineQuotationDoc_delete(data) {
  return request({
    url: '/qingguang/tenantbussiness/fineQuotationDoc/delete',
    method: 'post',
    data: data
  })
}

// 精细报价单组打印
export function fineQuotationDoc_groupPrint(data) {
  return request({
    url: '/qingguang/tenantbussiness/fineQuotationDoc/groupPrint',
    method: 'post',
    data: data
  })
}


// 精细报价单审核
export function fineQuotationDoc_checkFineQuotationDoc(data) {
  return request({
    url: '/qingguang/tenantbussiness/fineQuotationDoc/checkFineQuotationDoc',
    method: 'post',
    data: data
  })
}

// 查询精细报价单详情
export function fineQuotationDoc_view(data) {
  return request({
    url: '/qingguang/tenantbussiness/fineQuotationDoc/viewAll',
    method: 'get',
    params: data
  })
}

// 查询精细报价单详情（分离）
export function fineQuotationDoc_viewAllSeparate(data) {
  return request({
    url: '/qingguang/tenantbussiness/fineQuotationDoc/viewAllSeparate',
    method: 'get',
    params: data
  })
}

// 销售出库单打印（送货单）
export function logisticsOrderDoc_getLogisticsOrderDocForPrintByDocId(data) {
  return request({
    url: '/qingguang/tenantbussiness/logisticsOrderDoc/getLogisticsOrderDocForPrintByDocId',
    method: 'get',
    params: data
  })
}

// 报价单展开接口
export function smgtSalesQuotationDoc_selectSalesQuotationOtherList(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesQuotationDocDetail/selectSalesQuotationOtherList',
    method: 'post',
    data: data
  })
}

// 通过报价单
export function smgtSalesQuotationDoc_passQuotationOrderDoc(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesQuotationDoc/passQuotationOrderDoc',
    method: 'post',
    data: data
  })
}

// 修改报价单成交状态
export function smgtSalesQuotationDoc_updateStatusTransaction(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesQuotationDoc/updateStatusTransaction',
    method: 'post',
    data: data
  })
}

// 出库回写出库数量操作
export function changeExportAmountSmgtSalesDeliveryDoc(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesDeliveryDoc/changeExportAmountSmgtSalesDeliveryDoc',
    method: 'post',
    data: data
  })
}

//   出库反出库
export function smgtSalesDeliveryDoc_doExportInSmgtSalesDeliveryDoc(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesDeliveryDoc/doExportInSmgtSalesDeliveryDoc',
    method: 'post',
    data: data
  })
}

// 生产需要的报价单
export function smgtSalesQuotationDoc_listAfterCheck(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesQuotationDoc/listAfterCheck',
    method: 'post',
    data: data
  })
}

// 出库单打印
export function smgtSalesDeliveryDoc_deliveryDocForPrint(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesDeliveryDoc/deliveryDocForPrint',
    method: 'get',
    params: data
  })
}

// 生成产品
export function doProduct(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesQuotationDoc/buildMaterialInfo',
    method: 'post',
    data: data
  })
}

// 新增售后单
export function afterSalesSituation_add(data) {
  return request({
    url: '/qingguang/tenantbussiness/afterSalesSituation/add',
    method: 'post',
    data: data
  })
}

// 售后单列表
export function afterSalesSituation_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/afterSalesSituation/list',
    method: 'post',
    data: data
  })
}

// 售后单删除
export function afterSalesSituation_delete(data) {
  return request({
    url: '/qingguang/tenantbussiness/afterSalesSituation/delete',
    method: 'post',
    data: data
  })
}

// 售后单审核
export function afterSalesSituation_check(data) {
  return request({
    url: '/qingguang/tenantbussiness/afterSalesSituation/check',
    method: 'post',
    data: data
  })
}

// 售后单取消审核
export function afterSalesSituation_cancellationCheck(data) {
  return request({
    url: '/qingguang/tenantbussiness/afterSalesSituation/cancellationCheck',
    method: 'post',
    data: data
  })
}

// 售后单单独修改状态
export function updateStatusDoc(data) {
  return request({
    url: '/qingguang/tenantbussiness/afterSalesSituation/updateStatusDoc',
    method: 'post',
    data: data
  })
}



// 售后单更新
export function afterSalesSituation_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/afterSalesSituation/update',
    method: 'post',
    data: data
  })
}

// 出库单详细
export function afterSalesSituation_view(data) {
  return request({
    url: '/qingguang/tenantbussiness/afterSalesSituation/view',
    method: 'get',
    params: data
  })
}

// 销售订单展开
export function smgtSalesOrderDocDetail_selectSalesOrderOtherListWithExt(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesOrderDocDetail/selectSalesOrderOtherListWithExt',
    method: 'post',
    data: data
  })
}

// 查询可出库销售订单主表
export function smgtSalesOrderDoc_listV2(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesDeliveryDoc/selectUnDeliveryOrderMainList',
    method: 'post',
    data: data
  })
}

// 发货
export function smgtSalesOrderDoc_automaticGenerationSalesDeliveryDoc(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/automaticGenerationSalesDeliveryDoc',
    method: 'post',
    data: data
  })
}

//转生产计划
export function salesOrderDocTurnProducePlanDoc(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/salesOrderDocTurnProducePlanDoc',
    method: 'post',
    data: data
  })
}

//是否可以转请购
export function canSalesOrderDocTurnToPurchasesRequisitionDoc(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/canSalesOrderDocTurnToPurchasesRequisitionDoc',
    method: 'get',
    params: data
  })
}


//样品单列表
export function smgtSalesSampleDocList(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesSampleDoc/list',
    method: 'post',
    data: data
  })
}

//样品单详情
export function smgtSalesSampleDocView(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesSampleDoc/view',
    method: 'get',
    params: data
  })
}


//添加样品单
export function smgtSalesSampleDocAdd(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesSampleDoc/add',
    method: 'post',
    data: data
  })
}


//修改样品单
export function smgtSalesSampleDocUpdate(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesSampleDoc/update',
    method: 'post',
    data: data
  })
}


//审核样品单
export function smgtSalesSampleDocCheck(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesSampleDoc/passSalesSampleDoc',
    method: 'post',
    data: data
  })
}


//样品单删除
export function smgtSalesSampleDocDelete(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesSampleDoc/delete',
    method: 'post',
    data: data
  })
}

// 样品单汇总
export function smgtSalesSampleDocDetail_getSalesSampleDocListForSummary(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesSampleDocDetail/getSalesSampleDocListForSummary',
    method: 'post',
    data: data
  })
}

//样品单子表列表
export function smgtSalesSampleDocDetailList(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesSampleDocDetail/list',
    method: 'post',
    data: data
  })
}

//样品单子表列表
export function selectSalesSampleDocList(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesSampleDocDetail/selectSalesSampleDocList',
    method: 'post',
    data: data
  })
}

//未设置交期样品单
export function selectSalesSampleDocListWhenDeliverDateIsNull(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesSampleDocDetail/selectSalesSampleDocListWhenDeliverDateIsNull',
    method: 'post',
    data: data
  })
}

//样品通告
export function updateStatusTransaction(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesSampleDoc/updateStatusTransaction',
    method: 'post',
    data: data
  })
}
//已设置交期样品单
export function selectSalesSampleDocListWhenDeliverDateIsNotNull(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesSampleDocDetail/selectSalesSampleDocListWhenDeliverDateIsNotNull',
    method: 'post',
    data: data
  })
}


//样品单详情
export function smgtSalesSampleDocDetailView(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesSampleDocDetail/view',
    method: 'get',
    params: data
  })
}


//添加样品单
export function smgtSalesSampleDocDetailAdd(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesSampleDocDetail/add',
    method: 'post',
    data: data
  })
}


//修改样品单
export function smgtSalesSampleDocDetailUpdate(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesSampleDocDetail/update',
    method: 'post',
    data: data
  })
}


//样品单删除
export function smgtSalesSampleDocDetailDelete(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesSampleDocDetail/delete',
    method: 'post',
    data: data
  })
}

// 查询未对账收款数据
export function selectStatementReceiptGroupDocList(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtStatementReceiptDoc/selectStatementReceiptGroupDocList',
    method: 'post',
    data: data
  })
}

// 新增未对账收款数据
export function selectStatementReceiptGroupDocListByCustomerId(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtStatementReceiptDoc/selectStatementReceiptGroupDocListByCustomerId',
    method: 'post',
    data: data
  })
}

// 样品状态修改
export function updateProduceSampleStatus(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesSampleDocDetail/updateProduceSampleStatus',
    method: 'post',
    data: data
  })
}

// 样品时间修改
export function updateProduceDeliveryDate(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesSampleDocDetail/updateProduceDeliveryDate',
    method: 'post',
    data: data
  })
}

// 样品发货状态修改
export function updateSalesSampleDocStatusDelivery(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesSampleDoc/updateSalesSampleDocStatusDelivery',
    method: 'post',
    data: data
  })
}

// 根据产品Id查询副单位
export function queryMaterialUnit(data) {
  return request({
    url: '/qingguang/tenantbussiness/materialUnit/queryMaterialUnit',
    method: 'get',
    params: data
  })
}

// 销售转委外
export function outsourcingDoc_fromSalesOrderToOutsourcing(data) {
  return request({
    url: '/qingguang/tenantbussiness/outsourcingDoc/fromSalesOrderToOutsourcing',
    method: 'post',
    data: data
  })
}


// 样品出库列表
export function getViewBySalesSampleOrderDocId(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesSampleDoc/getViewBySalesSampleOrderDocId',
    method: 'get',
    params: data
  })
}

// 样品出库
export function doExportInSalesSampleDoc(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesSampleDoc/doExportInSalesSampleDoc',
    method: 'post',
    data: data
  })
}

// 样品撤销出库
export function rollBackExportInSalesSampleDoc(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesSampleDoc/rollBackExportInSalesSampleDoc',
    method: 'post',
    data: data
  })
}

// 样品单转请购 传参：salesSampleOrderDocId
export function smgtSalesSampleDoc_toRequisition(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesSampleDoc/toRequisition',
    method: 'post',
    data: data
  })
}

// 样品出库
export function profitReport(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/profitReport',
    method: 'post',
    data: data
  })
}

// 修改销单状态
export function updateSalesOrderDocStatusDoc(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/updateSalesOrderDocStatusDoc',
    method: 'post',
    data: data
  })
}

// 修改销单出库状态
export function updateSalesDeliveryDocStatusDoc(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesDeliveryDoc/updateSalesDeliveryDocStatusDoc',
    method: 'post',
    data: data
  })
}

// 修改销单收款状态
export function updateSalesStatementDocStatusDoc(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesStatementDoc/updateSalesStatementDocStatusDoc',
    method: 'post',
    data: data
  })
}

// 修改报价状态
export function updateSalesQuotationDocStatusDoc(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/updateSalesQuotationDocStatusDoc',
    method: 'post',
    data: data
  })
}

// 销售退货 状态修改
export function updateSalesChargebackDocStatusDoc(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtSalesChargebackDoc/updateSalesChargebackDocStatusDoc',
      method: 'post',
      data: data
  })
}

// 合并审核精细报价单
export function mergeCheckFineQuotationDoc(data) {
  return request({
      url: '/qingguang/tenantbussiness/fineQuotationDoc/mergeCheckFineQuotationDoc',
      method: 'post',
      data: data
  })
}

// 合并审核销售退货单
export function mergeCheckSalesChargebackDoc(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtSalesChargebackDoc/mergeCheckSalesChargebackDoc',
      method: 'post',
      data: data
  })
}

// 合并审核销售出库单
export function mergeCheckSalesDeliveryDoc(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtSalesDeliveryDoc/mergeCheckSalesDeliveryDoc',
      method: 'post',
      data: data
  })
}

// 合并审核销售单
export function mergeCheckSalesOrderDoc(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/mergeCheckSalesOrderDoc',
      method: 'post',
      data: data
  })
}

// 合并审核报价单
export function mergeCheckSalesQuotationDoc(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtSalesQuotationDoc/mergeCheckSalesQuotationDoc',
      method: 'post',
      data: data
  })
}

// 已审核并且未经过mrp计算的销售订单
export function smgtSalesOrderDoc_afterCheckAndBeforeMrpList(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/afterCheckAndBeforeMrpList',
      method: 'post',
      data: data
  })
}

// 客户应收接口
export function getShouldReceiptMoneyTotalByCustomer(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtSalesStatementDoc/getShouldReceiptMoneyTotalByCustomer',
      method: 'post',
      data: data
  })
}

// 客户应收汇总接口
export function getShouldReceiptMoneyTotalForSummary(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtSalesStatementDoc/getShouldReceiptMoneyTotalForSummary',
      method: 'post',
      data: data
  })
}

// 精细报价单转草稿BOM
export function fineQuotationDoc_transferToBomDraft(data) {
  return request({
      url: '/qingguang/tenantbussiness/fineQuotationDoc/transferToBomDraft',
      method: 'post',
      data: data
  })
}

// 客户已对账应收接口
export function getShouldReceiptMoneyTotalByCustomerForSalesStatementDoc(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtSalesStatementDoc/getShouldReceiptMoneyTotalByCustomerForSalesStatementDoc',
      method: 'post',
      data: data
  })
}

// 精细报价单转bom,发布已审核的bom新版本
export function fineQuotationDoc_transferToPublishNewVersionBom(data) {
  return request({
      url: '/qingguang/tenantbussiness/fineQuotationDoc/transferToPublishNewVersionBom',
      method: 'post',
      data: data
  })
}

// 精细报价单生产BOM方案和覆盖方案
export function fineQuotationDoc_transferToBomNewProgramme(data) {
  return request({
      url: '/qingguang/tenantbussiness/fineQuotationDoc/transferToBomNewProgramme',
      method: 'post',
      data: data
  })
}

// 售后维修单查询
export function smgtAfterSalesRepairDoc_list(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtAfterSalesRepairDoc/selectSmgtAfterSalesRepairDocListWithExt',
      method: 'post',
      data: data
  })
}

// 售后维修单新增
export function smgtAfterSalesRepairDoc_add(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtAfterSalesRepairDoc/add',
      method: 'post',
      data: data
  })
}

// 售后维修单修改
export function smgtAfterSalesRepairDoc_update(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtAfterSalesRepairDoc/update',
      method: 'post',
      data: data
  })
}

// 售后维修单详情
export function smgtAfterSalesRepairDoc_view(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtAfterSalesRepairDoc/view',
      method: 'get',
      params: data
  })
}

// 售后维修单删除
export function smgtAfterSalesRepairDoc_delete(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtAfterSalesRepairDoc/delete',
      method: 'post',
      data: data
  })
}

// 售后维修单审核
export function smgtAfterSalesRepairDoc_checkSmgtAfterSalesRepairDoc(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtAfterSalesRepairDoc/checkSmgtAfterSalesRepairDoc',
      method: 'post',
      data: data
  })
}

// 售后维修单发货
export function smgtAfterSalesRepairDoc_afterSalesRepairDocDelivery(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtAfterSalesRepairDoc/afterSalesRepairDocDelivery',
      method: 'post',
      data: data
  })
}

// 售后维修单收货
export function smgtAfterSalesRepairDoc_afterSalesRepairDocReceipt(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtAfterSalesRepairDoc/afterSalesRepairDocReceipt',
      method: 'post',
      data: data
  })
}

// 售后维修单状态修改
export function smgtAfterSalesRepairDoc_updateSalesQuotationDocStatusDoc(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtAfterSalesRepairDoc/updateSalesQuotationDocStatusDoc',
      method: 'post',
      data: data
  })
}

// 物料计划查询销售订单接口
export function mrpDoc_selectSalesOrderListByStatusMrpAndStatusDeliveryAndOrderDate(data) {
  return request({
      url: '/qingguang/tenantbussiness/mrpDoc/selectSalesOrderListByStatusMrpAndStatusDeliveryAndOrderDate',
      method: 'post',
      data: data
  })
}

// 来料列表
export function incomingMaterialProcessDoc_list(data) {
  return request({
      url: '/qingguang/tenantbussiness/incomingMaterialProcessDoc/getIncomingMaterialProcessDocListWithExt',
      method: 'post',
      data: data
  })
}

// 来料删除
export function incomingMaterialProcessDoc_delete(data) {
  return request({
      url: '/qingguang/tenantbussiness/incomingMaterialProcessDoc/delete',
      method: 'post',
      data: data
  })
}

// 来料新增
export function incomingMaterialProcessDoc_add(data) {
  return request({
      url: '/qingguang/tenantbussiness/incomingMaterialProcessDoc/add',
      method: 'post',
      data: data
  })
}

// 来料修改
export function incomingMaterialProcessDoc_update(data) {
  return request({
      url: '/qingguang/tenantbussiness/incomingMaterialProcessDoc/update',
      method: 'post',
      data: data
  })
}

// 来料详情
export function incomingMaterialProcessDoc_view(data) {
  return request({
      url: '/qingguang/tenantbussiness/incomingMaterialProcessDoc/view',
      method: 'get',
      params: data
  })
}

// 来料子表详情
export function incomingMaterialProcessDocDetail_view(data) {
  return request({
      url: '/qingguang/tenantbussiness/qingguang/tenantbussiness/incomingMaterialProcessDocDetail/view',
      method: 'get',
      params: data
  })
}

// 来料审核
export function incomingMaterialProcessDoc_checkIncomingMaterialProcessDoc(data) {
  return request({
      url: '/qingguang/tenantbussiness/incomingMaterialProcessDoc/checkIncomingMaterialProcessDoc',
      method: 'post',
      data: data
  })
}

// 来料入库
export function incomingMaterialProcessDoc_doWarehouseBussinessInboundForIncomingMaterialProcessDoc(data) {
  return request({
      url: '/qingguang/tenantbussiness/incomingMaterialProcessDoc/doWarehouseBussinessInboundForIncomingMaterialProcessDoc',
      method: 'post',
      data: data
  })
}

// 来料退货列表
export function incomingMaterialChargebackDoc_list(data) {
  return request({
      url: '/qingguang/tenantbussiness/incomingMaterialChargebackDoc/list',
      method: 'post',
      data: data
  })
}

// 来料退货删除
export function incomingMaterialChargebackDoc_delete(data) {
  return request({
      url: '/qingguang/tenantbussiness/incomingMaterialChargebackDoc/delete',
      method: 'post',
      data: data
  })
}

// 来料退货审核
export function incomingMaterialChargebackDoc_checkIncomingMaterialChargebackDoc(data) {
  return request({
      url: '/qingguang/tenantbussiness/incomingMaterialChargebackDoc/checkIncomingMaterialChargebackDoc',
      method: 'post',
      data: data
  })
}

// 来料退货新增
export function incomingMaterialChargebackDoc_add(data) {
  return request({
      url: '/qingguang/tenantbussiness/incomingMaterialChargebackDoc/add',
      method: 'post',
      data: data
  })
}

// 来料退货修改
export function incomingMaterialChargebackDoc_update(data) {
  return request({
      url: '/qingguang/tenantbussiness/incomingMaterialChargebackDoc/update',
      method: 'post',
      data: data
  })
}

// 来料退货详情
export function incomingMaterialChargebackDoc_view(data) {
  return request({
      url: '/qingguang/tenantbussiness/incomingMaterialChargebackDoc/view',
      method: 'get',
      params: data
  })
}

// 来料退货出库
export function incomingMaterialChargebackDoc_doWarehouseBussinessOutboundForIncomingMaterialChargebackDoc(data) {
  return request({
      url: '/qingguang/tenantbussiness/incomingMaterialChargebackDoc/doWarehouseBussinessOutboundForIncomingMaterialChargebackDoc',
      method: 'post',
      data: data
  })
}

// 来料退货撤销出库
export function incomingMaterialChargebackDoc_revokeWarehouseBussinessOutboundForIncomingMaterialChargebackDoc(data) {
  return request({
      url: '/qingguang/tenantbussiness/incomingMaterialChargebackDoc/revokeWarehouseBussinessOutboundForIncomingMaterialChargebackDoc',
      method: 'post',
      data: data
  })
}

// 销售预测列表
export function smgtSalesPredictionDoc_getSmgtSalesPredictionDocListWithExt(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtSalesPredictionDoc/getSmgtSalesPredictionDocListWithExt',
      method: 'post',
      data: data
  })
}

// 销售预测审核
export function smgtSalesPredictionDoc_checkSmgtSalesPredictionDoc(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtSalesPredictionDoc/checkSmgtSalesPredictionDoc',
      method: 'post',
      data: data
  })
}

// 销售预测新增
export function smgtSalesPredictionDoc_add(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtSalesPredictionDoc/add',
      method: 'post',
      data: data
  })
}

// 销售预测修改
export function smgtSalesPredictionDoc_update(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtSalesPredictionDoc/update',
      method: 'post',
      data: data
  })
}

// 销售预测详情
export function smgtSalesPredictionDoc_view(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtSalesPredictionDoc/view',
      method: 'get',
      params: data
  })
}

// 销售预测删除
export function smgtSalesPredictionDoc_delete(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesPredictionDoc/delete',
    method: 'post',
    data: data
  })
}

// 销售预测单修改状态
export function smgtSalesPredictionDoc_updateStatusDoc(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesPredictionDoc/updateStatusDoc',
    method: 'post',
    data: data
  })
}

// 样品单新增迭代
export function smgtSalesSampleDoc_iterativeSample(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtSalesSampleDoc/iterativeSample',
      method: 'post',
      data: data
  })
}

// 样品单迭代记录
export function smgtSalesSampleDoc_queryHistorySample(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtSalesSampleDoc/queryHistorySample',
      method: 'post',
      data: data
  })
}

// 销售选择客户更新价格
export function material_queryPriceAndExtByIdForBatch(data) {
  return request({
      url: '/qingguang/tenantbussiness/material/queryPriceAndExtByIdForBatch',
      method: 'post',
      data: data
  })
}

// MRP销售预测单
export function mrpDoc_selectSalesPredictionListByStatusMrpAndStatusDeliveryAndOrderDate(data) {
  return request({
      url: '/qingguang/tenantbussiness/mrpDoc/selectSalesPredictionListByStatusMrpAndStatusDeliveryAndOrderDate',
      method: 'post',
      data: data
  })
}

// 样品单撤销出库
export function smgtSalesSampleDoc_rollBackExportInSalesSampleDocByDeliveryJson(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtSalesSampleDoc/rollBackExportInSalesSampleDocByDeliveryJson',
      method: 'post',
      data: data
  })
}

// 修改销售单子表信息
export function smgtSalesOrderDocDetail_updateById(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtSalesOrderDocDetail/updateById',
      method: 'post',
      data: data
  })
}

// 销售月度接单
export function smgtSalesOrderDoc_getSaleMonthReportList(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/getSaleMonthReportList',
      method: 'post',
      data: data
  })
}

// 来料加工 根据订单的产品查出对应的BOM物料
export function smgtSalesOrderDoc_getMaterialListBySalesDocList(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/getMaterialListBySalesDocList',
      method: 'post',
      data: data
  })
}

// 销售齐套性
export function smgtSalesOrderDoc_querySalesOrderStatusKitting(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/querySalesOrderStatusKitting',
      method: 'post',
      data: data
  })
}

// 销售入库联级新增
export function smgtSalesDeliveryDoc_addSalesDeliveryDocAutoCreateOtherDoc(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtSalesDeliveryDoc/addSalesDeliveryDocAutoCreateOtherDoc',
      method: 'post',
      data: data
  })
}

// 客户对账单批量审核
export function smgtSalesStatementDoc_mergeCheckSalesStatementDoc(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtSalesStatementDoc/mergeCheckSalesStatementDoc',
      method: 'post',
      data: data
  })
}

//销售换货添加
export function salesBarterDocDetail_add(data) {
  return request({
      url: '/qingguang/tenantbussiness/salesBarterDocDetail/add',
      method: 'post',
      data: data
  })
}

//销售换货添加
export function updateSalesBarterDocStatusDoc(data) {
  return request({
      url: '/qingguang/tenantbussiness/salesBarterDoc/updateSalesBarterDocStatusDoc',
      method: 'post',
      data: data
  })
}

//销售换货修改
export function salesBarterDocDetail_update(data) {
  return request({
      url: '/qingguang/tenantbussiness/salesBarterDocDetail/update',
      method: 'post',
      data: data
  })
}

//销售换货列表
export function selectSalesBarterDocListWithExt(data) {
  return request({
      url: '/qingguang/tenantbussiness/salesBarterDocDetail/selectSalesBarterDocListWithExt',
      method: 'post',
      data: data
  })
}

//销售换货添加
export function sell_exchange_add(data) {
  return request({
      url: '/qingguang/tenantbussiness/salesBarterDoc/add',
      method: 'post',
      data: data
  })
}

//销售换货详情
export function sell_exchange_view(data) {
  return request({
      url: '/qingguang/tenantbussiness/salesBarterDoc/view',
      method: 'get',
      params: data
  })
}

//销售换货修改
export function smgtsalesBarterDoc_delete(data) {
  return request({
      url: '/qingguang/tenantbussiness/salesBarterDoc/delete',
      method: 'post',
      data: data
  })
}

//销售换货修改
export function smgtsalesBarterDoc_update(data) {
  return request({
      url: '/qingguang/tenantbussiness/salesBarterDoc/update',
      method: 'post',
      data: data
  })
}

//销售换货审核
export function checkSalesBarterDoc(data) {
  return request({
      url: '/qingguang/tenantbussiness/salesBarterDoc/checkSalesBarterDoc',
      method: 'post',
      data: data
  })
}

//换货单转入库
export function doEntranceForSalesBarterDoc(data) {
  return request({
      url: '/qingguang/tenantbussiness/salesBarterDoc/doEntranceForSalesBarterDoc',
      method: 'post',
      data: data
  })
}

//换货单转出库
export function doExportForSalesBarterDoc(data) {
  return request({
      url: '/qingguang/tenantbussiness/salesBarterDoc/doExportForSalesBarterDoc',
      method: 'post',
      data: data
  })
}

// 销单出库利润报表
export function costProfitReport_generate(data) {
  return request({
      url: '/qingguang/tenantbussiness/costProfitReport/generate',
      method: 'post',
      data: data
  })
}

//换货单转出库撤销
export function rollBackExportInSalesBarterDocByDeliveryJson(data) {
  return request({
      url: '/qingguang/tenantbussiness/salesBarterDoc/rollBackExportInSalesBarterDocByDeliveryJson',
      method: 'post',
      data: data
  })
}

//换货单转入库撤销
export function rollBackEntranceInSalesBarterDocByDeliveryJson(data) {
  return request({
      url: '/qingguang/tenantbussiness/salesBarterDoc/rollBackEntranceInSalesBarterDocByDeliveryJson',
      method: 'post',
      data: data
  })
}

//修改销单子表状态
export function smgtSalesOrderDoc_updateSalesOrderDocDetailStatusDoc(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/updateSalesOrderDocDetailStatusDoc',
      method: 'post',
      data: data
  })
}

//修改销单主表
export function smgtSalesOrderDoc_updateSalesOrderDocContract(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/updateSalesOrderDocContract',
      method: 'post',
      data: data
  })
}

//销售计划 新增
export function salesPlanDoc_add(data) {
  return request({
      url: '/qingguang/tenantbussiness/salesPlanDoc/add',
      method: 'post',
      data: data
  })
}

//销售计划 删除
export function salesPlanDoc_delete(data) {
  return request({
      url: '/qingguang/tenantbussiness/salesPlanDoc/delete',
      method: 'post',
      data: data
  })
}

//销售计划 修改
export function salesPlanDoc_update(data) {
  return request({
      url: '/qingguang/tenantbussiness/salesPlanDoc/update',
      method: 'post',
      data: data
  })
}

//销售计划 修改
export function salesPlanDoc_list(data) {
  return request({
      url: '/qingguang/tenantbussiness/salesPlanDoc/getSalesPlanAchievementRateList',
      method: 'post',
      data: data
  })
}

//销售计划 修改
export function salesPlanDoc_view(data) {
  return request({
      url: '/qingguang/tenantbussiness/salesPlanDoc/view',
      method: 'get',
      params: data
  })
}

//  销售计划完成率
export function salesPlanDoc_getSalesPlanCompletionRateByMonth(data) {
  return request({
      url: '/qingguang/tenantbussiness/salesPlanDoc/getSalesPlanCompletionRateByMonth',
      method: 'post',
      data: data
  })
}

// 生成销售出库利润表数据
export function costProfitReport_generateByTimeRange(data) {
  return request({
      url: '/qingguang/tenantbussiness/costProfitReport/generateByTimeRange',
      method: 'post',
      data: data
  })
}

// 销售出库利润表点击物料成本
export function productionMaterialConsumptionDetail_list(data) {
  return request({
      url: '/qingguang/tenantbussiness/productionMaterialConsumptionDetail/list',
      method: 'post',
      data: data
  })
}

// 销售详情查询的出库单
export function smgtSalesDeliveryDocDetail_selectSalesDeliveryListBySalesOrderIdList(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtSalesDeliveryDocDetail/selectSalesDeliveryListBySalesOrderIdList',
      method: 'post',
      data: data
  })
}

// 售后维修单出入库明细
export function smgtAfterSalesRepairDoc_getAfterSalesRepairWarehouseFlowList(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtAfterSalesRepairDoc/getAfterSalesRepairWarehouseFlowList',
      method: 'post',
      data: data
  })
}

// 撤销售后维修单出入库明细
export function smgtAfterSalesRepairDoc_rollbackAfterSalesRepairWarehouseFlow(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtAfterSalesRepairDoc/rollbackAfterSalesRepairWarehouseFlow',
      method: 'post',
      data: data
  })
}

// 销单批量转生产
export function smgtSalesOrderDoc_querySalesOrderContainDetailByIdList(data) {
    return request({
        url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/querySalesOrderContainDetailByIdList',
        method: 'post',
        data: data
    })
}

// 获取未出库预计成本明细
export function smgtSalesOrderDoc_getUndeliveryEstimatedCostDetail(data) {
    return request({
        url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/getUndeliveryEstimatedCostDetail',
        method: 'post',
        data: data
    })
}

// 获取出库成本明细
export function smgtSalesOrderDoc_getOutboundCostDetail(data) {
    return request({
        url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/getOutboundCostDetail',
        method: 'post',
        data: data
    })
}

// 销售预测转采购中转接口
export function smgtSalesPredictionDoc_selectSalesPredictionListForPurchaseByIds(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtSalesPredictionDoc/selectSalesPredictionListForPurchaseByIds',
      method: 'post',
      data: data
  })
}

// 样品明细单 list
export function fineSampleDoc_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/fineSampleDoc/list',
    method: 'post',
    data: data
  })
}

// 样品明细单 view
export function fineSampleDoc_view(data) {
  return request({
    url: '/qingguang/tenantbussiness/fineSampleDoc/view',
    method: 'get',
    params: data
  })
} 

// 样品明细单 add
export function fineSampleDoc_add(data) {
  return request({
    url: '/qingguang/tenantbussiness/fineSampleDoc/add',
    method: 'post',
    data: data
  })
}

// 样品明细单 update
export function fineSampleDoc_update(data) {  
  return request({
    url: '/qingguang/tenantbussiness/fineSampleDoc/update',
    method: 'post',
    data: data
  })
}

// 样品明细单 delete
export function fineSampleDoc_delete(data) {
  return request({
    url: '/qingguang/tenantbussiness/fineSampleDoc/delete',
    method: 'post',
    data: data
  })
}

// 样品明细单 check
export function fineSampleDoc_checkFineSampleDoc(data) {
  return request({
    url: '/qingguang/tenantbussiness/fineSampleDoc/checkFineSampleDoc',
    method: 'post',
    data: data
  })
}

// 样品明细单 样品出库
export function fineSampleDoc_doExportForFineSampleDoc(data) {
  return request({
    url: '/qingguang/tenantbussiness/fineSampleDoc/doExportForFineSampleDoc',
    method: 'post',
    data: data
  })
}

// 样品明细单 撤销样品出库
export function fineSampleDoc_rollBackExportInFineSampleDocByDeliveryJson(data) {
  return request({
    url: '/qingguang/tenantbussiness/fineSampleDoc/rollBackExportInFineSampleDocByDeliveryJson',
    method: 'post',
    data: data
  })
}

// 样品明细单 组装出库
export function fineSampleDoc_doAssemblyOutbound(data) {
  return request({
    url: '/qingguang/tenantbussiness/fineSampleDoc/doAssemblyOutbound',
    method: 'post',
    data: data
  })
}

// 样品明细单 撤销组装出库
export function fineSampleDoc_rollBackAssemblyOutbound(data) {
  return request({
    url: '/qingguang/tenantbussiness/fineSampleDoc/rollBackAssemblyOutbound',
    method: 'post',
    data: data
  })
}

// 售后单据 修改指派人
export function afterSalesSituation_updateAssignee(data) {
  return request({
    url: '/qingguang/tenantbussiness/afterSalesSituation/updateAssignee',
    method: 'post',
    data: data
  })
}

// 销售报价单修改图片和附件
export function smgtSalesQuotationDoc_updateDrawingAndFile(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesQuotationDoc/updateDrawingAndFile',
    method: 'post',
    data: data
  })
}

// 样品单修改图片和附件
export function smgtSalesSampleDoc_updateDrawingAndFile(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesSampleDoc/updateDrawingAndFile',
    method: 'post',
    data: data
  })
}

// 产品报价单修改图片和附件
export function fineQuotationDoc_updateDrawingAndFile(data) {
  return request({
    url: '/qingguang/tenantbussiness/fineQuotationDoc/updateDrawingAndFile',
    method: 'post',
    data: data
  })
}

// 销售账单根据未对账直接创建对账单
export function smgtStatementReceiptDoc_createStatementDocFromGroupQuery(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtStatementReceiptDoc/createStatementDocFromGroupQuery',
    method: 'post',
    data: data
  })
}

// 拼装销售阶段性付款
export function smgtSalesOrderDoc_getSalesStatementDocListBySalesOrderDocId(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/getSalesStatementDocListBySalesOrderDocId',
    method: 'post',
    data: data
  })
}

// 修改销售阶段性付款
export function smgtSalesOrderDoc_updateSalesOrderStagePaymentJson(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/updateSalesOrderStagePaymentJson',
    method: 'post',
    data: data
  })
}

// 获取关联电商数据
export function smgtSalesOrderDocDetail_getEcommerceBySalesOrderDocId(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesOrderDocDetail/getEcommerceBySalesOrderDocId',
    method: 'post',
    data: data
  })
}


// 销售退货入库
export function smgtSalesChargebackDoc_doEnranceInSalesChargebackReceiptDoc(data) {
  return request({
      url: '/qingguang/tenantbussiness/smgtSalesChargebackDoc/doEnranceInSalesChargebackReceiptDoc',
      method: 'get',
      params: data
  })
}

// 销单列表新接口 专门处理baseProjectId 和 globalSearchNumber的

// 查询销售订单
export function smgtSalesOrderDoc_selectSalesOrderListWithExtByProjectOrGlobalSearch(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesOrderDocDetail/selectSalesOrderListWithExtByProjectOrGlobalSearch',
    method: 'post',
    data: data
  })
}

// 查询销售订单可来料退货数据 
export function incomingMaterialChargebackDoc_listIncomingMaterialProcessDocBySalesOrderDocId(data) {
  return request({
    url: '/qingguang/tenantbussiness/incomingMaterialChargebackDoc/listIncomingMaterialProcessDocBySalesOrderDocId',
    method: 'post',
    data: data
  })
}

// 来料退货列表 
export function incomingMaterialChargebackDoc_getIncomingMaterialChargebackDocList(data) {
  return request({
    url: '/qingguang/tenantbussiness/incomingMaterialChargebackDoc/getIncomingMaterialChargebackDocList',
    method: 'post',
    data: data
  })
}

// 销售业绩统计
export function report_salesPerformance_statistics(data) {
  return request({
    url: '/qingguang/tenantbussiness/report/salesPerformance/statistics',
    method: 'post',
    data: data
  })
}

// 批量查询销售订单详情
export function smgtSalesOrderDoc_viewList(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesOrderDoc/viewList',
    method: 'post',
    data: data
  })
}
